module.exports = __webpack_public_path__ + "img/chat-details5.1958f366.png";